import { useNavigation } from 'react-router';
import Stripe from 'stripe'
import calculateAmounts from '~/lib/stripe/calculateAmounts'
import { CustomStripeProduct } from '~/lib/stripe/storeFrontProps'
import useTranslator from '~/lib/useTranslator'
import convertToCurrency from '~/utils/convertToCurrency'

export default function ListTier({
  product,
  coupon,
  currency,
  interval,
  locale,
  onSubmit,
}: {
  product: CustomStripeProduct
  coupon?: Stripe.Coupon
  interval: string
  currency: string
  locale: string
  onSubmit: (priceId: string) => void
}) {
  const Translator = useTranslator()
  const navigation = useNavigation()

  const isLoading = navigation.state === 'loading'

  const p = product.prices?.find((price) => price.recurring?.interval === interval) as Stripe.Price
  const amounts = calculateAmounts(currency, p, 1, coupon)

  if (!amounts) {
    return null
  }

  return (
    <div className="flex flex-col md:flex-row md:items-center px-8 py-4 border-b">
      <div className="flex flex-row grow gap-4 py-4 items-center">
        <img
          src={product.images[0] || ''}
          className="rounded-md"
          width={44}
          height={44}
          alt="logo"
        />
        <div>
          <h6 className="text-xl font-medium">{product.name}</h6>
          <div className="text-sm text-black/75  leading-none">
            {Translator.singular('{{ amount }} per team and {{ interval }}', {
              amount: convertToCurrency(locale, currency, amounts.total),
              interval: p.recurring?.interval ?? '',
            })}
            {(amounts.max_price || 0) > amounts.total && (
              <div className="line-through text-black/30 leading-none">
                {Translator.singular('{{ amount }} per team', {
                  amount: convertToCurrency(locale, currency, amounts.max_price),
                })}
              </div>
            )}
          </div>
        </div>
      </div>
      <div>
        <button
          type="submit"
          disabled={isLoading}
          name="priceId"
          value={p.id}
          className="text-white px-4 py-2 rounded-md w-full md:w-auto bg-purple-dark"
          onClick={() => {
            onSubmit(p.id)
          }}
        >
          {Translator.singular('Start 14 day trial')}
        </button>
      </div>
    </div>
  )
}
